import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { GalleryCarouselModel } from './models/galleryCarousel.model';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import GalleryCarousel from './components/galleryCarousel';

const FullScreenMediaGallery = (props) => {
  const model = new GalleryCarouselModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <section className={'fullscreen-media-gallery'}>
      <GalleryCarousel model={model} rendering={props.rendering} />
    </section>
  );
};

export default withSitecoreContext()(FullScreenMediaGallery);
